export default __webpack_public_path__ + "static/media/whatsapp-inverted.5aa15baa.png";